import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShoppingBag } from 'lucide-react';
import { products } from '../data/products';
import MerchHeader from '../components/MerchHeader';
import Footer from '../components/Footer';

const Merch = () => {
  return (
    <div className="min-h-screen bg-[#f8f4ee]">
      <MerchHeader />

      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-b from-[#0a1030] via-[#111a4a] to-[#0a1030] text-white">
        <div className="absolute inset-0 opacity-30 bg-[radial-gradient(ellipse_at_top,rgba(200,185,138,0.35),transparent_60%)]" />
        <div className="relative max-w-[1000px] mx-auto text-center px-6 py-20 md:py-24">
          <p className="text-[12px] tracking-[0.3em] uppercase text-[#c8b98a] mb-5">
            ACT Shop
          </p>
          <h1
            className="text-[46px] md:text-[76px] lg:text-[92px] leading-[1.02]"
            style={{ fontFamily: 'Fraunces, serif', fontWeight: 500 }}
          >
            Merch
          </h1>
          <p className="mt-6 text-[17px] md:text-[19px] text-white/85 max-w-[620px] mx-auto leading-relaxed">
            Rep the family. Every piece is designed with intention — pick yours,
            check out with PayPal, and pick it up at the church on Sunday.
          </p>
        </div>
      </section>

      {/* Products */}
      <section className="py-16 md:py-20 px-4 md:px-6">
        <div className="max-w-[1300px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {products.map((p) => (
              <Link
                key={p.slug}
                to={`/merch/product/${p.slug}`}
                className="group bg-white rounded-2xl overflow-hidden border border-black/5 shadow-sm hover:shadow-md transition-all"
              >
                <div className="aspect-square overflow-hidden bg-[#f4f2ef]">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="text-[11px] uppercase tracking-wider text-[#8a7a4a] font-semibold">
                    {p.category}
                  </div>
                  <h3
                    className="mt-1 text-[22px] md:text-[24px] text-[#0a1030] leading-tight"
                    style={{ fontFamily: 'Fraunces, serif', fontWeight: 500 }}
                  >
                    {p.name}
                  </h3>
                  <div className="mt-3 flex items-center justify-between">
                    <div className="text-[18px] font-semibold text-[#0a1030]">
                      ${p.price}
                    </div>
                    <div className="inline-flex items-center gap-1 text-[13px] font-semibold text-[#0a1030] group-hover:gap-2 transition-all">
                      Shop <ArrowRight className="h-3.5 w-3.5" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-16 text-center max-w-[560px] mx-auto text-sm text-[#5a5148] flex flex-col items-center gap-2">
            <ShoppingBag className="h-5 w-5 text-[#8a7a4a]" />
            <p>
              All orders are pickup only at 370 Tomkins Court, Gilroy CA —
              usually available for pickup the following Sunday after your
              order is confirmed.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Merch;
